import { render, staticRenderFns } from "./HomeGenerico.vue?vue&type=template&id=1c217f5a&scoped=true&"
import script from "./HomeGenerico.vue?vue&type=script&lang=ts&"
export * from "./HomeGenerico.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c217f5a",
  null
  
)

export default component.exports